import type { SubPageKeys } from '@common/enums/pages.enum'
import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import type { FC, PropsWithChildren } from 'react'
import { memo, Suspense, useMemo } from 'react'
import { useLocation } from 'react-router-dom-v7'
import { useAbandonOrder } from '@/common/hooks/useAbandonOrder'
import { PageLoading } from '../content/pages/helpers/PageLoading'
import { navigationService } from '../content/services/navigation.service'

export const SubPageWrapper: FC<PropsWithChildren<{ page: SubPageKeys }>> = memo(({ page, children }) => {
    const logger = useLogger('SubPageWrapper')
    const location = useLocation()

    // Run in useMemo instead of useEffect to ensure this is run during the render phase.
    useMemo(() => {
        logger.debug('Updating current subpage', { page })

        navigationService.setCurrentSubPage(page)
        // eslint-disable-next-line react-hooks/exhaustive-deps -- only run on page change
    }, [location.key, page])

    useAbandonOrder()

    logger.trace('Rendering', { page })

    return <Suspense fallback={<PageLoading />}>{children}</Suspense>
})
